<template>
  <popper class="js-popper" trigger="hover"
          :options="{
      placement: position,
      modifiers: { offset: { offset: '0,8px' } }
    }" :class="'s-' + id">
    <div class="popper popcorn-tooltip" :class="{'is-click': isClick}" role="tooltip">
      {{ tooltip }}
      <slot name="tooltip"></slot>
    </div>
    <span class="popcorn" aria-describedby="tooltip" @click="hinted" slot="reference"><slot></slot></span>
  </popper>
</template>

<script>

  import Popper from 'vue-popperjs';
  import 'vue-popperjs/dist/vue-popper.css';

  export default {
    name: "VuePopper",
    data: function() {
      let position = "top";
      if(this.placement){
        position = this.placement;
      }
      return {
        position: position,
        popcornEl: false,
        tooltipEl: false,
        popperInstance: false,
        tooltip: this.hint,
        isClick: false
      };
    },
    props: {
      id: [String, Number],
      hint: String,
      hintClick: String,
      placement: String
    },
    methods: {
      show: function () {
        this.tooltipEl.setAttribute('data-show', '');
      },
      hide: function () {
        this.tooltipEl.removeAttribute('data-show');
        this.tooltip = this.hint;
        this.isClick = false;
      },
      hinted: function () {
        if (this.hintClick) {
          this.$emit('hinted', event);
          this.isClick = true;
          this.tooltip = this.hintClick;
        } else {
          return false;
        }
      }
    },
    mounted() {

      this.popcornEl = document.querySelector('.js-popper.s-' + this.id + ' .popcorn');
      this.tooltipEl = document.querySelector('.js-popper.s-' + this.id + ' .popcorn-tooltip');

      const showEvents = ['mouseenter', 'focus'];
      const hideEvents = ['mouseleave', 'blur'];

      showEvents.forEach((event) => {
        this.popcornEl.addEventListener(event, this.show);
      });

      hideEvents.forEach((event) => {
        this.popcornEl.addEventListener(event, this.hide);
      });

    },
    components: {
      'popper': Popper
    },
  }
</script>

<style>

  .popcorn-tooltip {
    background: #009adf;
    color: #fff;
    font-size: 11px;
    font-weight: 300;
    padding: 5px 10px;
    border-radius: 4px;

    border:none;
    box-shadow:none;
  }

  .popcorn-tooltip.is-click {
    background: #ffc831;
    color: #fff;
  }

  .popcorn-tooltip[data-show]  {
    display: block;
  }

  .popper .popper__arrow,
  .popper .popper__arrow::before {
    position: absolute;
    width: 8px;
    height: 8px;
    background: inherit;
  }

  .popper .popper__arrow {
    visibility: hidden;
  }

  .popper .popper__arrow::before {
    visibility: visible;
    content: '';
    transform: rotate(45deg);
  }

  .popper[x-placement^="top"] .popper__arrow{
    bottom: 1px !important;
    left: calc(50% - 14px) !important;
  }
  .popper[x-placement^="bottom"] .popper__arrow {
    top: -1px;
  }

  .popper[x-placement^="left"] .popper__arrow {
    right: 2px;
  }

  .popper[x-placement^="right"] .popper__arrow {
    left: -1px;
  }

</style>